module.exports = __webpack_public_path__ + "static/Muli-Italic.db0192bf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-Italic.ttf
// module id = 336
// module chunks = 114276838955818